export class Permission {
    uuid?: string;
    name?: string;
    friendlyName?: string;
}